/* eslint-disable quote-props */
export const insurerCodeNameMapping = {
  '793': 'ACE INA INSURANCE COMPANY',
  '451': 'ALBERTA MOTOR INSURANCE COMPANY',
  'A01': 'ALGOMA MUTUAL INSURANCE COMPANY',
  '096': 'ALLIANZ GLOBAL RISK US INSURANCE COMPANY',
  '325': 'ALLSTATE INSURANCE COMPANY OF CANADA',
  '755': "ALPHA, COMPAGNIE D'ASSURANCES INC.",
  '341': 'ALPINA INSURANCE COMPANY LIMITED',
  '476': 'AMERICAN ROAD INSURANCE COMPANY, THE',
  '101': 'ARCH INSURANCE COMPANY',
  '725': 'ATLANTIC INSURANCE COMPANY LIMITED',
  '157': 'AVIVA INSURANCE',
  '073': 'AXA CANADA',
  '459': 'AXA GENERAL INSURANCE',
  'A03': "AYR FARMERS' MUTUAL INSURANCE COMPANY",
  'A04': 'BAY OF QUINTE MUTUAL INSURANCE COMPANY',
  '077': 'BELAIRDIRECT/NORDIC INSURANCE COMPANY OF CANADA',
  'A05': 'BERTIE AND CLINTON MUTUAL INSURANCE COMPANY',
  'A07': 'BRANT MUTUAL INSURANCE COMPANY',
  '762': 'C.A.A. INSURANCE COMPANY',
  '746': 'CABOT INSURANCE COMPANY LIMITED',
  '339': 'CANADIAN COMMERCE INSURANCE COMPANY , THE',
  '062': 'CANADIAN DIRECT INSURANCE INC',
  '903': 'CANADIAN GENERAL INSURANCE COMPANY',
  '098': "CANADIAN MILLERS' MUTUAL INSURANCE COMPANY",
  '414': 'CANADIAN PROVINCIAL INSURANCE COMPANY , THE',
  '165': 'CANASSURANCE GENERAL INSURANCE CO. INC',
  '773': "CAPITALE, COMPAGNIE D'ASSURANCE GENERALE",
  'A08': 'CARADOC DELAWARE MUTUAL FIRE INSURANCE COMPANY',
  'A09': 'CAYUGA MUTUAL INSURANCE COMPANY',
  '686': 'CENTENNIAL INSURANCE COMPANY',
  '562': 'CERTAS DIRECT INSURANCE COMPANY',
  '676': 'CHARTIS INSURANCE COMPANY OF CANADA',
  '053': 'CHIEFTAIN INSURANCE COMPANY',
  '819': 'CHUBB INSURANCE COMPANY OF CANADA',
  '810': 'COACHMAN INSURANCE COMPANY',
  '445': 'CONTINENTAL INSURANCE COMPANY , THE',
  '771': "COOPERANTS, COMPAGNIE D'ASSURANCE GENERALE",
  '361': 'CO-OPERATORS GENERAL INSURANCE COMPANY',
  '160': 'CORNHILL INSURANCE COMPANY OF CANADA',
  '899': 'COSECO INSURANCE COMPANY',
  '497': 'CUMIS GENERAL INSURANCE COMPANY',
  '575': 'DESJARDINS ASSURANCES GENERALES INC.',
  '007': 'DOMINION OF CANADA GENERAL INSURANCE COMPANY',
  'A12': 'DUFFERIN MUTUAL INSURANCE COMPANY',
  'A13': 'DUMFRIES MUTUAL INSURANCE COMPANY',
  '027': 'ECHELON GENERAL INSURANCE COMPANY',
  '094': 'ECONOMICAL MUTUAL INSURANCE COMPANY',
  '100': 'ELECTRIC INSURANCE COMPANY',
  '511': 'ELITE INSURANCE COMPANY',
  'A18': 'ERIE MUTUAL FIRE INSURANCE COMPANY',
  '807': "FARMERS' MUTUAL FIRE INSURANCE COMPANY",
  '189': 'FEDERAL INSURANCE COMPANY',
  '008': 'FEDERATED INSURANCE COMPANY OF CANADA',
  '171': 'FEDERATED MUTUAL INSURANCE COMPANY',
  '365': 'FEDERATION INSURANCE COMPANY OF CANADA',
  '532': 'FIRE INSURANCE COMPANY OF CANADA , THE',
  '435': 'GAN CANADA GENERAL INSURANCE COMPANY',
  '669': 'GCAN INSURANCE COMPANY',
  '873': 'GENERAL ACCIDENT INDEMNITY COMPANY , THE',
  'A21': 'GERMANIA MUTUAL INSURANCE COMPANY',
  '655': 'GORE MUTUAL INSURANCE COMPANY',
  'A23': 'GRENVILLE MUTUAL INSURANCE COMPANY',
  '842': "GROUPE ESTRIE-RICHELIEU, COMPAGNIE D'ASSURANCE",
  '538': 'GUARANTEE COMPANY OF NORTH AMERICA , THE',
  'A25': 'HALWELL MUTUAL INSURANCE COMPANY',
  '069': 'HARTFORD FIRE INSURANCE COMPANY',
  'A27': 'HAY MUTUAL INSURANCE COMPANY',
  '085': 'HOME INSURANCE COMAPNY',
  'A28': 'HOWARD MUTUAL INSURANCE COMPANY',
  'A29': 'HOWICK MUTUAL INSURANCE COMPANY',
  'A26': 'HTM INSURANCE COMPANY',
  '757': "INDUSTRIELLE-ALLIANCE, COMPAGNIE D'ASSURANCE",
  '211': 'INSURANCE COMPANY OF PRINCE EDWARD ISLAND',
  '523': "INTACT COMPAGNIE D'ASSURANCE",
  '167': 'INTACT INSURANCE COMPANY',
  '828': 'JEVCO INSURANCE COMPANY',
  '092': 'KEMPER CANADA',
  'A30': 'KENT AND ESSEX MUTUAL INSURANCE COMPANY',
  'A33': 'L & A MUTUAL INSURANCE COMPANY',
  '885': 'LA PERSONNELLE, ASSURANCES GENERALES INCL',
  'A31': 'LAMBTON MUTUAL INSURANCE COMPANY',
  '621': 'LIBERTY MUTUAL INSURANCE COMPANY',
  '274': "LLOYD'S UNDERWRITERS",
  '554': "L'UNION CANADIENNE, COMPAGNIE D'ASSURANCES",
  '796': "L'UNIQUE GENERAL INSURANCE",
  'A37': 'MCKILLOP MUTUAL INSURANCE COMPANY',
  '729': 'METRO GENERAL INSURANCE CORP. LTD.',
  'A54': 'MIDDLESEX MUTUAL INSURANCE COMPANY',
  '064': 'MILLENIUM INSURANCE CORPORATION',
  '402': 'MISSISQUOI INSURANCE COMPANY, THE',
  '820': 'MITSUI SUMITOMO INSURANCE COMPANY LIMITED',
  '163': 'MOTORS INSURANCE CORPORATION',
  '009': 'MUNICIPAL ELECTRIC ASSOCIATION RECIPROCAL INSURANCE',
  '288': 'NORDIC INSURANCE',
  'A38': 'NORFOLK MUTUAL INSURANCE COMPANY',
  'A39': 'NORTH BLENHEIM MUTUAL INSURANCE COMPANY',
  'A40': 'NORTH KENT MUTUAL FIRE INSURANCE COMPANY',
  '568': 'NORTH WATERLOO MUTUAL INSURANCE COMPANY',
  '760': 'NORTHBRIDGE COMMERCIAL INSURANCE CORPORATION',
  '850': 'NORTHBRIDGE GENERAL INSURANCE CORPORATION',
  '161': 'NORTHBRIDGE PERSONAL INSURANCE CORPORTATION',
  '020': 'NOVEX INSURANCE COMPANY',
  '398': 'OLD REPUBLIC INSURANCE COMPANY OF CANADA',
  '043': "ONTARIO SCHOOL BOARDS' INSURANCE EXCHANGE",
  '843': 'OPTIMUM ASSURANCE AGRICOLE',
  '816': 'OPTIMUM INSURANCE COMPANY',
  '116': "OPTIMUM SOCIETE D'ASSURANCE INC",
  '590': 'OPTIMUM WEST INSURANCE COMPANY',
  '417': 'PAFCO INSURANCE COMPANY LTD',
  '075': 'PEACE HILLS GENERAL INSURANCE COMPANY',
  'A44': 'PEEL MARYBOROUGH MUTUAL INSURANCE COMPANY',
  'A43': 'PEEL MUTUAL INSURANCE COMPANY',
  '059': 'PEMBRIDGE INSURANCE COMPANY',
  '269': 'PEOPLEPLUS INSURANCE',
  '766': 'PERSONAL INSURANCE COMPANY OF CANADA, THE',
  '428': 'PERTH INSURANCE COMPANY',
  '213': 'PORTAGE LA PRAIRE MUTUAL INSURANCE COMPANY',
  'A45': 'PRESCOTT MUTUAL INSURANCE COMPANY',
  '896': 'PRIMMUM INSURANCE COMPANY',
  '835': 'PROGRESSIVE CASUALTY INSURANCE COMPANY',
  '855': 'PROMUTUEL APALACHES, SMAG',
  '858': 'PROMUTUEL BAGOT, SMAG',
  '846': 'PROMUTUEL BEAUCE, SMAG',
  '857': 'PROMUTUEL BELLECHASSE, SMAG',
  '870': 'PROMUTUEL BOIS-FRANCS, SMAG',
  '833': 'PROMUTUEL CHARLEVOIX-MONTMORENCY, SMAG',
  '890': 'PROMUTUEL COATICOOK-SHERBROOKE, SMAG',
  '834': 'PROMUTUEL DES RIVERAINS, SMAG',
  '894': 'PROMUTUEL DEUX-MONTAGNES, SMAG',
  '868': 'PROMUTUEL DRUMMOND, SMAG',
  '866': 'PROMUTUEL DU LAC AU FJORD',
  '891': 'PROMUTUEL FRONTENAC, SMAG',
  '826': 'PROMUTUEL GASPESIE LES ILES, SMAG',
  '822': 'PROMUTUEL HAUT ST-LAURENT, SMAG',
  '844': 'PROMUTUEL KAMOURASKA, SMAG',
  '892': 'PROMUTUEL LA VALLEE, SMAG',
  '893': "PROMUTUEL L'ABITIBIENNE, SMAG",
  '821': 'PROMUTUEL LANAUDIERE, SMAG',
  '875': 'PROMUTUEL LES PRAIRIES, SMAG',
  '847': 'PROMUTUEL LEVISIENNE-ORLEANS, SMAG',
  '881': "PROMUTUEL L'OUTAOUAIS, SMAG",
  '883': 'PROMUTUEL MAURICIENNE, SMAG',
  '887': 'PROMUTUEL MONTMAGNY, SMAG',
  '859': 'PROMUTUEL PORTNEUF-CHAMPLAIN, SMAG',
  '830': 'PROMUTUEL REASSURANCE, SMAG',
  '865': 'PROMUTUEL RIVIERE-DU-LOUP, SMAG',
  '860': 'PROMUTUEL SAGUENAY, SMAG',
  '882': 'PROMUTUEL SOULANGES, SMAG',
  '862': 'PROMUTUEL VALMONT, SMAG',
  '836': 'PROMUTUEL VAUDREUIL, SMAG',
  '876': 'PROMUTUEL VERCHERES, SMAG',
  '014': 'PROTECTIVE INSURANCE COMPANY',
  '578': 'QUEBEC ASSURANCE COMPANY',
  '079': 'RBC GENERAL INSURANCE COMPANY (ALBERTA)',
  '031': 'RBC GENERAL INSURANCE COMPANY',
  '040': 'ROYAL & SUN ALLIANCE INSURANCE COMPANY OF CANADA',
  '086': 'S & Y INSURANCE COMPANY',
  '675': 'SAFECO INSURANCE COMPANY OF AMERICA',
  '260': 'SASKATCHEWAN MUTUAL INSURANCE COMPANY',
  '016': 'SCOTIA GENERAL INSURANCE COMPANY',
  '446': 'SCOTTISH & YORK INSURANCE COMPANY LIMITED',
  '614': "SECURITE NATIONALE, COMPAGNIE D'ASSURANCE",
  '135': 'SECURITY INSURANCE COMPANY OF HARTFORD',
  '357': "SELECTA NATIONAL D'ASSURANCES INC.",
  '756': 'SENTRY INSURANCE, A MUTUAL COMPANY',
  '313': 'SGI CANADA INSURANCE SERVICES LIMITED',
  '124': 'SONNET INSURANCE COMPANY',
  'A46': 'SOUTH EASTHOPE MUTUAL INSURANCE COMPANY',
  '370': 'SOVEREIGN GENERAL INSURANCE COMPANY, THE',
  '898': "SSQ, SOCIETE D'ASSURANCES GENERALES INC.",
  '113': 'ST. PAUL FIRE AND MARINE INSURANCE COMPANY, THE',
  '685': 'STATE FARM FIRE & CASUALTY COMPANY',
  '645': 'STATE FARM MUTUAL AUTOMOBILE INSURANCE COMPANY',
  '455': "ST-MAURICE, COMPAGNIE D'ASSURANCE",
  '034': 'TD GENERAL INSURANCE COMPANY',
  '683': 'TIG INSURANCE COMPANY',
  '588': 'TOKIO MARINE & NICHIDO FIRE INSURANCE COMPANY',
  'A55': 'TOWN AND COUNTRY MUTUAL INSURANCE COMPANY',
  'A48': "TOWNSEND FARMERS' MUTUAL FIRE INSURANCE COMPANY",
  '346': 'TRADERS GENERAL INSURANCE COMPANY',
  'A56': 'TRADITION MUTUAL INSURANCE COMPANY',
  '824': 'TRAFALGAR INSURANCE COMPANY OF CANADA',
  '186': 'TRAVELERS GUARANTEE COMPANY OF CANADA',
  'A57': 'TRILLIUM MUTUAL INSURANCE COMPANY',
  '099': 'TRISURA GUARANTEE INSURANCE COMPANY',
  '731': 'UNIFUND ASSURANCE COMPANY',
  '299': "UNION CANADIENNE, COMPAGNIE D'ASSURANCES",
  '543': 'UNITED GENERAL INSURANCE CORPORATION',
  '206': 'UNITED STATES FIRE INSURANCE COMPANY',
  '999': 'UNKNOWN',
  'A49': 'USBORNE AND HIBBERT MUTUAL FIRE INSURANCE COMPANY',
  '673': 'UTICA MUTUAL INSURANCE COMPANY',
  'A50': 'WABISA MUTUAL INSURANCE COMPANY',
  '633': 'WATERLOO INSURANCE COMPANY',
  '207': 'WAWANESA MUTUAL INSURANCE COMPANY, THE',
  'A14': 'WEST ELGIN MUTUAL INSURANCE COMPANY',
  'A52': 'WEST WAWANOSH MUTUAL INSURANCE COMPANY',
  '032': 'WESTERN ASSURANCE COMPANY',
  '849': 'WESTERN GENERAL MUTUAL INSURANCE COMPANY',
  'A51': 'WESTMINSTER MUTUAL INSURANCE COMPANY',
  '081': 'XL INSURANCE COMPANY LIMITED',
  'A53': 'YARMOUTH MUTUAL FIRE INSURANCE COMPANY',
  '303': 'YORK FIRE AND CASUALTY INSURANCE COMPANY',
  '021': 'ZENITH INSURANCE COMPANY',
  '119': 'ZURICH INSURANCE COMPANY LTD.',
};
